import { render } from "./HotCountry.vue?vue&type=template&id=7aefcaea&scoped=true"
import script from "./HotCountry.vue?vue&type=script&lang=js"
export * from "./HotCountry.vue?vue&type=script&lang=js"

import "./HotCountry.vue?vue&type=style&index=0&id=7aefcaea&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aefcaea"]])

export default __exports__